---
label: Sign In
category: core
icon: LogInIcon
keywords: [sign in, login, log in, auth, account, kinde, invite, private beta]
addedInVersion: "0.0.0"
---

# Sign In

Gnomux is invite-only during the private beta. If you don't have an invite,
the sign-in screen will let you know new access requests aren't being
accepted.

## Signing In

Click **Sign in** on the splash screen. You'll be redirected to sign in, then
returned to Gnomux once you're authenticated.

## Signing Out

Sign out from [Account Settings](/settings/account).
